// extracted by mini-css-extract-plugin
module.exports = {"card":"_-_-pharmacy-src-display-card-card__card--W8Iag","cardClick":"_-_-pharmacy-src-display-card-card__cardClick--opU3X"};